import { render, staticRenderFns } from "./InputFieldTemplate.vue?vue&type=template&id=570b39a4&scoped=true&"
import script from "./InputFieldTemplate.vue?vue&type=script&lang=js&"
export * from "./InputFieldTemplate.vue?vue&type=script&lang=js&"
import style0 from "./InputFieldTemplate.vue?vue&type=style&index=0&id=570b39a4&prod&lang=scss&"
import style1 from "./InputFieldTemplate.vue?vue&type=style&index=1&id=570b39a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570b39a4",
  null
  
)

export default component.exports